import { Button, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	title: string;
	canUnpin: boolean;
	isPending: boolean;
	onUnpin: () => void;
};

export const PinnedItemRow: FC<Props> = ({
	title,
	canUnpin,
	isPending,
	onUnpin,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={theme.spacingTokens.md}
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
			sx={{
				borderBottom: theme.colors.border.solid(theme.palette.grey[100]),
				"&:last-of-type": { borderBottom: "none" },
			}}
		>
			<Typography
				variant="bodyMedium"
				color={theme.palette.grey[900]}
				flex={1}
				minWidth={0}
				overflow="hidden"
				whiteSpace="nowrap"
				textOverflow="ellipsis"
			>
				{title}
			</Typography>
			{canUnpin && (
				<Button
					variant="textLink"
					color="error"
					disableRipple
					disabled={isPending}
					onClick={onUnpin}
					sx={{ flexShrink: 0 }}
				>
					{t(Resources.PortfolioDetail.Pin.unpin)}
				</Button>
			)}
		</Stack>
	);
};
